import { useNavigate, useParams } from 'react-router-dom'
import { ConvertorMiladi } from 'utilities/helper/digitToMonth'
interface IItemProps {
    item: IMoneyPoolLoansResult
}
export default function Item({ item }: IItemProps) {
    const navigate = useNavigate()
    const { id } = useParams()

    const payPercent =
        item.number_of_repayments > 0
            ? item.number_of_repaid_installments / item.number_of_repayments
            : 0
    const payWidth = `${Math.min(payPercent, 1) * 100}%`

    return (
        <div
            className="relative mx-4 mb-2 overflow-hidden rounded-card border border-[#E4E7EB] bg-white cursor-pointer active:scale-[0.99]"
            onClick={() =>
                navigate(
                    `/fund/financial-history/funds-detail/${id}/${item.poolship_id}/${item.id}`,
                    { state: { name: item.poolship_name } }
                )
            }
        >
            {/* pay_view: repayment progress band filled from the right (RTL parent end) */}
            <div
                className="absolute inset-y-0 right-0"
                style={{
                    width: payWidth,
                    // tints, matching the members' band: text sits on top
                    backgroundColor: item.is_fully_repaid
                        ? '#EEF0F2'
                        : '#74B74338',
                }}
            />

            {item.has_deleyed_installment && !item.is_fully_repaid ? (
                <div className="absolute top-0 left-1/2 z-[1] -translate-x-1/2 w-[65px] rounded-b-[8px] bg-danger p-0.5 text-center">
                    <span className="text-xs text-white">معوق</span>
                </div>
            ) : null}

            <div className="relative z-[1] grid min-h-[65px] grid-cols-3 items-center">
                {/* right (RTL first): borrower name */}
                <div className="mt-1.5 flex justify-end pr-2.5">
                    <p className="text-base font-bold text-black">
                        {item.poolship_name}
                    </p>
                </div>

                {/* center: installment count or settled tag */}
                <div className="flex justify-center">
                    {item.is_fully_repaid ? (
                        <span className="rounded-full bg-white/80 px-2 py-0.5 text-xs font-bold text-gray-1 ring-1 ring-[#E4E7EB]">
                            تسویه شده
                        </span>
                    ) : (
                        <span className="text-sm text-black">
                            {item.number_of_repayments} قسط
                        </span>
                    )}
                </div>

                {/* left (RTL last): amount + date */}
                <div className="mt-1.5 flex flex-col items-start pl-2.5">
                    <p className="text-sm font-bold text-black">
                        {item.amount && item.amount.toLocaleString()} تومان
                    </p>
                    <p className="text-xs text-black">
                        {item?.pay_date && ConvertorMiladi(item.pay_date)}
                    </p>
                </div>
            </div>

            {/* The figure a manager's «ترتیب» sorted by — only sent under
                that sort, so a list ordered by it can be checked at a glance. */}
            {item.first_overdue_due_date && (
                <div className="relative z-[1]">
                    <div className="mx-2.5 h-px bg-[#E4E7EB]" />
                    <p className="px-2.5 py-1.5 text-xs text-danger-on">
                        معوق از {ConvertorMiladi(item.first_overdue_due_date)}
                        {item.overdue_amount
                            ? `، ${item.overdue_amount.toLocaleString()} تومان`
                            : ''}
                    </p>
                </div>
            )}
            {!!item.remaining_amount && (
                <div className="relative z-[1]">
                    <div className="mx-2.5 h-px bg-[#E4E7EB]" />
                    <p className="px-2.5 py-1.5 text-xs text-black">
                        مانده وام: {item.remaining_amount.toLocaleString()}{' '}
                        تومان
                    </p>
                </div>
            )}

            {item.tag && (
                <div className="relative z-[1]">
                    <div className="mx-2.5 h-px bg-[#E4E7EB]" />
                    <p className="px-2.5 py-1.5 text-xs text-text-body">
                        توضیحات:‌ {item.tag}
                    </p>
                </div>
            )}
        </div>
    )
}
